module.exports = __webpack_public_path__ + "img/pets_404.419a407d.svg";